import {ChangeDetectorRef, Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2} from "@angular/core";
import {Subscription} from "rxjs";
import {FUIResponsiveService} from "../../page/responsive.service";

@Directive({
    selector: "[fui-column-width]"
})
export class FUIColumnWidthDirective implements OnInit, OnDestroy {
    @Input("fui-column-width") columnWidth: number;
    @Input() columns: number = 2;
    @Input() columnGap: number = 12;

    private subscriptions: Subscription = new Subscription();

    constructor(private element: ElementRef,
                private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: FUIResponsiveService,
                private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.recalculate();
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => {
            this.recalculate();
        }));
    }

    private recalculate(): void {
        if ((this.element.nativeElement.clientWidth - (this.columnGap * (this.columns - 1))) / this.columns < this.columnWidth) {
            this.renderer.addClass(this.element.nativeElement, "wrap-columns");
        } else {
            this.renderer.removeClass(this.element.nativeElement, "wrap-columns");
        }
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
